import { Button, Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { Outlet } from 'react-router-dom';

import { CreateFormLayout } from 'components/layouts';
import { FormActionEntityState } from 'entities/FormActions';
import { translateApiValue } from 'utils/translateApiValue';

import { FormReviewPageContextProvider, useFormReviewPage } from './context';

export const FormReviewPage: React.FC = () => {
  const { route, store, extraHeaderButtons, formName } = useFormReviewPage();

  const actionButtons = React.useMemo(() => {
    if (!store) {
      return [];
    }

    return store.actions.map((item) => (
      <Button
        onClick={() => {
          store.executeAction(item);
        }}
        disabled={item.state === FormActionEntityState.disabled}
        loading={store.formActionExecuteRequest.loading}
        type="primary"
        key={item.title}
      >
        {item.title}
      </Button>
    ));

    // eslint-disable-next-line
  }, [store?.actions, store?.formActionExecuteRequest.loading]);

  const buttonNodes = React.useMemo(() => {
    return (
      <>
        {extraHeaderButtons}
        {actionButtons}
      </>
    );
  }, [extraHeaderButtons, actionButtons]);

  return (
    <CreateFormLayout
      buttonNodes={buttonNodes}
      pathBack={route}
      titleNode={
        formName ? (
          <Typography.Title level={2} style={{ margin: 0 }}>
            {translateApiValue(formName)}
          </Typography.Title>
        ) : undefined
      }
    >
      <Outlet />
    </CreateFormLayout>
  );
};

const FormReviewPageObserved = observer(FormReviewPage);

const FormReviewPageWithContext = () => {
  return (
    <FormReviewPageContextProvider>
      <FormReviewPageObserved />
    </FormReviewPageContextProvider>
  );
};

export default FormReviewPageWithContext;
